import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';

import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth/auth.service';
import { LayoutService } from '../../services/layout/layout.service';

@Component({
  selector: 'app-topbar',
  imports: [
    RouterModule,
    RouterLink,
    CommonModule,
    MenuModule
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  private _layoutService = inject(LayoutService);
  private _authService = inject(AuthService);
  private _router = inject(Router);

  @ViewChild('searchinput') searchInput!: ElementRef;
  @ViewChild('menubutton') menuButton!: ElementRef;

  public menu: MenuItem[] = [];
  public searchActive: boolean = false;
  public profile: any | null = null;

  public menuItems = [
    {
      items: [
        { label: 'Cerra sesión', icon: 'pi pi-power-off', command: this.logout.bind(this) },
      ],
    },
  ];

  ngOnInit(): void {
    this.profile = this._authService.activeUser;
  }

  onMenuButtonClick() {
    this._layoutService.onMenuToggle();
  }

  removeTab(event: MouseEvent, item: MenuItem, index: number) {
    this._layoutService.onTabClose(item, index);
    event.preventDefault();
  }

  get layoutTheme(): string {
    return this._layoutService.config.layoutTheme;
  }

  get colorScheme(): string {
    return this._layoutService.config.colorScheme;
  }

  get tabs(): MenuItem[] {
    return this._layoutService.tabs;
  }

  logout(): void {
    this._authService.logout();
  }
}
